module.exports = __webpack_public_path__ + "879e91f8.svg";